import axios from 'axios'

const url = 'https://gdp-dev-clube.s3.amazonaws.com/auxiliaryFiles/testimonials.json'

export const getTestimonials = async () => {
  try {
    const response = await axios.get(url)
    return response.data
  } catch (e) {
    console.log({ error: e })
    return []
  }
}
